import * as React from 'react'

import { styled } from '@thg-commerce/gravity-theme'
import { GlobalReferral3StepGuide } from '@thg-commerce/enterprise-network/src/generated/graphql'
import {
  ReferralStepGuide,
  ReferralStepGuideProps,
  IconType,
} from '@thg-commerce/enterprise-widget-referral-step-guide'

import { BaseWidgetProps } from '../types'

export type ReferralStepGuideRendererProps = BaseWidgetProps &
  Omit<
    GlobalReferral3StepGuide,
    'id' | 'query' | 'step1icon' | 'step2icon' | 'step3icon'
  > & { step1icon: IconType; step2icon: IconType; step3icon: IconType }

const StyledReferralStepGuide = styled(ReferralStepGuide)`
  max-width: ${(props) => props.theme.site.siteWidth};
  margin: 0 auto;
`

export const ReferralStepGuideRenderer = (
  props: ReferralStepGuideRendererProps,
) => {
  if (
    !props.step1icon ||
    !props.step1title ||
    !props.step1text ||
    !props.step2text ||
    !props.step2icon ||
    !props.step2title ||
    !props.step3icon ||
    !props.step3text ||
    !props.step3title
  ) {
    return null
  }

  const referralStepGuide: ReferralStepGuideProps = {
    title: props.title || undefined,
    subtitle: props.subtitle || undefined,
    smallprint: props.smallprint || undefined,
    step1icon: props.step1icon,
    step1title: props.step1title,
    step1text: props.step1text,
    step2text: props.step2text,
    step2icon: props.step2icon,
    step2title: props.step2title,
    step3icon: props.step3icon,
    step3text: props.step3text,
    step3title: props.step3title,
  }

  return <StyledReferralStepGuide {...referralStepGuide} />
}
